import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Hamburger = ({
  height = 24,
  width = 24,
  color = colors.textPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <line
      id="top-bar"
      x1="3"
      y1="4"
      x2="21"
      y2="4"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      id="middle-bar"
      x1="3"
      y1="12"
      x2="21"
      y2="12"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      id="bottom-bar"
      x1="3"
      y1="20"
      x2="21"
      y2="20"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
